<template>
  <div>
    <div
      class="Kanit primary pa-4 text-center white--text"
      style="font-size: 22px"
    >
      ลงทะเบียน
    </div>
    <div>
      <v-btn @click="$emit('prevstep')" text color="primary">
        <v-icon>mdi-chevron-left</v-icon>
        กลับ
      </v-btn>
    </div>
    <div class="pa-5">
      <div>
        <v-row class="pl-3">
          <v-col cols="5">
            <span class="headdata1"> เบอร์โทร </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.phoneNumber }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> ชื่อ </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.firstName }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> นามสกุล </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.lastName }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> วัน-เดือน-ปี เกิด </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{
              moment(input.dob).add(543, "year").format("DD/MM/YYYY")
            }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> อาชีพ </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.job }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> เลขบัตรประชาชน </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.identityNumber }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> อีเมล </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1">{{ input.email }}</span>
          </v-col>
          <v-col cols="5">
            <span class="headdata1"> ลงทะเบียนที่ </span>
          </v-col>
          <v-col cols="7">
            <span class="subdata1"
              >{{ input.departmentStore }} สาขา {{ input.branch }}</span
            >
          </v-col>
        </v-row>
      </div>

      <div class="mt-4">
        <v-btn
          @click="$emit('nextstep')"
          style="font-size: 22px"
          class="text-capitalize"
          color="primary"
          dark
          block
          >ยืนยัน</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  computed: {
    moment() {
      return moment;
    },
    input() {
      return this.$store.state.input;
    },
  },
};
</script>
<style>
.headdata1 {
  font-size: 17px;
  color: grey;
}
.subdata1 {
  font-size: 18px;
}
</style>